import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { fetchWorkdays } from "../actions/index";
import * as constants from "../const";
import HoursOfServiceModal from "./hours-of-service-modal";
import { showModalAction, getWorkdayAction,actErrorAction } from "../actions/index";
import moment from "moment";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/src/SuperResponsiveTableStyle.css";

class NonCertifiedPre16EmployeesWorkday extends React.Component {
  constructor(props) {
    super(props);
  }

  // showing popup with workday details
  showModal(modalObj) {
    
      this.props.onShowModal(modalObj.modalName);
      this.props.onActErr(false, false);
       var workdayDate = moment(modalObj.workdayDate, 'MM/DD/YYYY')
       workdayDate = workdayDate.format('YYYYMMDD');
       let role = this.props.role,
          self = this;
       this.props.getWorkday(
          constants.actionUrls.WORKDAY_URL + "/" + role + "/" + modalObj.workdayId + "/" + modalObj.certifyStatus
          + "/" + modalObj.empId + "/" + workdayDate + "/" + modalObj.dutyActivityStatus,
        function(response){
          if(response){
              if(response.latestRecords == false){
                  let latestRecords = response.latestRecords;
                  self.props.onActErr(true, false, response.errMsg, false);
              }
          }
        });
  }

  render() {
      var route = localStorage.getItem("route"),
          workday = this.props.workday,division = '-',
          full_name = workday && workday.emp_full_name != undefined ? workday.emp_full_name.split(" ") : '',
          first_name = full_name == '' ? '-' : full_name[1],
          last_name = full_name == '' ? '-' :  full_name[0];
      if(workday){
        if(workday.wdy_emp_phone_numbers){
          var empPhoneNumbers = workday.wdy_emp_phone_numbers,
          trimmedPhoneNumber = empPhoneNumbers.substring(0, 12),
          empPhoneNumbers =
          empPhoneNumbers ? empPhoneNumbers.length > 12
            ? trimmedPhoneNumber + "..."
            : trimmedPhoneNumber : '-';
        }
        division = workday.division;
      }
      var modal_name = workday.wdy_certify_status == constants.UNCERTIFIED ? constants.hosModals.Certify_Modal : constants.hosModals.Certified_Modal;
      var modalObj = {
            workdayId:workday.id,
            certifyStatus:workday.wdy_certify_status,
            empId:workday.demp_display_Id,
            workdayDate:workday.wdy_date,
            modalName:modal_name,
            dutyActivityStatus:workday.dutyActivityStatus
      }
    return (
      <tr  onClick={() => this.showModal(modalObj)} >
        <td data-title="Division">{division}</td>
        <td data-title="Employee ID" className="text-center">{workday.demp_display_Id}</td>
        <td data-title="Job" className="text-center">{workday.job_class}</td>        
        <td data-title="First Name" className="text-center"> {first_name} </td>
        <td data-title="Last Name" className="text-center"> {last_name} </td>
        <td data-title="Service Date" className="text-center"> {workday.wdy_date} </td>
        <td data-title="Phone" className="text-center">
          <span title={workday.wdy_emp_phone_numbers}>{empPhoneNumbers}</span>
        </td>
        <td data-title="HOS" className="text-center">
          {workday.wdy_working_time_hos_adjust ? (
            workday.wdy_working_time_hos_adjust
          ) : (
            workday.wdy_working_time_hos
          )}
        </td>
        <td data-title="TOS" className="text-center">
          {workday.wdy_spread_adjust ? (
            workday.wdy_spread_adjust
          ) : (
            workday.wdy_spread
          )}
        </td>
        <td data-title="Time Elapsed" className={"text-center "+ (route == constants.OUTLAW ? 'hidden' : '')}> {workday.timeElapsed}</td>
        
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    authDetails:state.authState
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onShowModal: showModalAction,
      onActErr: actErrorAction,
      getWorkday: getWorkdayAction
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(
  NonCertifiedPre16EmployeesWorkday
);
